export default __webpack_public_path__ + "static/media/11.8af4b7ef.png";